<mat-form-field
  [hideRequiredMarker]="true"
  [floatLabel]="to.floatLabel"
  [appearance]="to.appearance"
  [color]="to.color"
  [style.width]="'100%'">
  <mat-label *ngIf="to.label && to.hideLabel !== true">
    {{ to.label }}
    <span *ngIf="to.required && to.hideRequiredMarker !== true" class="mat-form-field-required-marker">* <span class="required">(required)</span></span>
  </mat-label>

  <div fxFlex fxFlexLayoutGap="10" fxFlexLayout="column">
    <div fxFlex="150px">
      <mat-button-toggle-group
        color="accent"
        appearance="legacy"
        name="fontStyle"
        aria-label="Font Style">
        <mat-button-toggle value="file" #fileButton (click)="fileInput.click()">
          <mat-icon>cloud_upload</mat-icon> File
        </mat-button-toggle>
        <mat-button-toggle #linkButton value="link"> Link</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div fxFlex>
      <input [readonly]="fileButton.checked" matInput type="text" [formControl]="formControl" [formlyAttributes]="field"
        [style.height]="'37px'" [style.padding]="'10px 0px 0px 0px'" [value]="fileInput.value"/>
    </div>

  </div>

  <input #fileInput hidden type="file" [formControl]="formControl" [formlyAttributes]="field"/>

</mat-form-field>
